import status from "./status";

export default function() {
  this.id = "";
  this.address = "";
  this.status = status.none;
  this.display = "";
}
